
const acfformOrganisationSetup = () => {
  const components = document.querySelectorAll('[data-component-acfform-organisation]');
  components.forEach((component) => {

  });


  jQuery(document).ready(function($) {
      var label = $("body.page-template-page-mijn-locatie label[for='acf-_post_title']");
      label.html("Naam organisatie <span class=\"acf-required\">*</span>");
  });


  // autofill the materialen bestellen fields with base location values
  $('.acf-field.aantal').on('click',function() {

    //console.log($(this).find('-on').length);

    // copy value adres
    if(!$('#acf-field_595500cf85214').val()) {
      $('#acf-field_595500cf85214').val($('#acf-field_55df20444fc72').val());
    }

    // copy value postcode
    if(!$('#acf-field_595500eb85215').val()) {
      $('#acf-field_595500eb85215').val($('#acf-field_55df20444fd16').val());
    }

    // copy value plaats
    if(!$('#acf-field_5955010a85216').val()) {
      $('#acf-field_5955010a85216').val($('#acf-field_55df20444fdb3').val());
    }
    
    // copy value provincie
    if(!$('#acf-field_597f1dd12f247').val()) {
      $('#acf-field_597f1dd12f247').val($('#acf-field_5b0beb962296e').val());
    }
     
  });

  // If all the materialen fields are hidden, than clear the adres values of materialen
  $('#locatie-form .acf-form-submit input').on('click',function() {
    if($('.acf-field-595500cf85214').hasClass('acf-hidden')) {
      $('#acf-field_595500cf85214').val('');
      $('#acf-field_595500eb85215').val('');
      $('#acf-field_5955010a85216').val('');
      $('#acf-field_597f1dd12f247').val('');
    }
  });





};
acfformOrganisationSetup();